export default __webpack_public_path__ + "static/media/indicator-sect5-pallette.b15eded2.svg";